import { render, staticRenderFns } from "./BarChartWidget.vue?vue&type=template&id=049db8b8&scoped=true"
import script from "./BarChartWidget.vue?vue&type=script&lang=js"
export * from "./BarChartWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049db8b8",
  null
  
)

export default component.exports